import { render, staticRenderFns } from "./SocialStatusLabel.vue?vue&type=template&id=6d6e8858&scoped=true&"
import script from "./SocialStatusLabel.vue?vue&type=script&lang=js&"
export * from "./SocialStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./SocialStatusLabel.vue?vue&type=style&index=0&id=6d6e8858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e8858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6e8858')) {
      api.createRecord('6d6e8858', component.options)
    } else {
      api.reload('6d6e8858', component.options)
    }
    module.hot.accept("./SocialStatusLabel.vue?vue&type=template&id=6d6e8858&scoped=true&", function () {
      api.rerender('6d6e8858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialStatusLabel.vue"
export default component.exports